import { enumOptionsToObject } from '../../internal'
import { AdditionalWaiverQuestion } from './additional-waiver-question'

export const predefinedIndianMotorcyclesQuestions: Record<
  PredefinedIndianMotorcyclesQuestionKey,
  Omit<AdditionalWaiverQuestion, 'id' | 'orderOfAppearance' | 'predefinedQuestionKey'>
> = {
  DoYouOwnAMotorcycle: {
    prompt: 'Do you currently own a motorcycle?',
    description: '',
    metadata: {
      type: 'checkboxOptional'
    }
  },
  BrandOwnedCurrently: {
    prompt: 'What brand do you currently own?',
    description: '',
    metadata: {
      type: 'multiselectOptional',
      options: [
        'BMW',
        'Can-Am',
        'Ducati',
        'Harley Davidson',
        'Honda',
        'Indian Motorcycle',
        'Kawasaki',
        'Suzuki',
        'Triumph',
        'Yamaha',
        'Other'
      ]
    }
  },
  ModelOwnedCurrently: {
    prompt: 'What type of motorcycle do you own?',
    description: '',
    metadata: {
      type: 'multiselectOptional',
      options: ['Standard', 'Cruiser', 'Bagger', 'Touring', '3-Wheel', 'Other']
    }
  },
  ModelsInterestedIn: {
    prompt: 'Which models are you interested in?',
    description: '',
    metadata: {
      type: 'multiselectOptional',
      options: [
        'Scout 1250',
        'Scout Sixty',
        'Chief',
        'Sport Chief',
        'Sport Chief RT / Super Chief',
        'Springfield',
        'Chieftain Thunderstroke',
        'Chieftain PowerPlus',
        'Roadmaster Thunderstroke',
        'Roadmaster PowerPlus',
        'Challenger',
        'Pursuit',
        'Slingshot S',
        'Slingshot SL',
        'Slingshot SLR',
        'Slingshot R'
      ]
    }
  }
}

export const predefinedIndianMotorcyclesQuestionKeyOptions = [
  'DoYouOwnAMotorcycle',
  'BrandOwnedCurrently',
  'ModelOwnedCurrently',
  'ModelsInterestedIn'
] as const

export const predefinedIndianMotorcyclesQuestionKeys = enumOptionsToObject(predefinedIndianMotorcyclesQuestionKeyOptions)

export type PredefinedIndianMotorcyclesQuestionKey = (typeof predefinedIndianMotorcyclesQuestionKeyOptions)[number]

export const predefinedIndianMotorcyclesQuestionKeyLabels: Record<PredefinedIndianMotorcyclesQuestionKey, string> = {
  DoYouOwnAMotorcycle: 'Do You Own A Motorcycle',
  BrandOwnedCurrently: 'Brand Owned Currently',
  ModelOwnedCurrently: 'Model Owned Currently',
  ModelsInterestedIn: 'Models Interested In'
}

// The code below is intended to make it easier to expand pre-defined questions in the future.

export const predefinedQuestions = { ...predefinedIndianMotorcyclesQuestions }

export const predefinedQuestionKeyOptions = [...predefinedIndianMotorcyclesQuestionKeyOptions] as const

export type PredefinedQuestionKey = PredefinedIndianMotorcyclesQuestionKey

export const predefinedQuestionKeyLabels: Record<PredefinedQuestionKey, string> = {
  ...predefinedIndianMotorcyclesQuestionKeyLabels
}
